import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export default class ScrollToController {
    constructor(options) {
        const _defaults = {
            scrollToLink: ".js-scroll-to",
        };

        this.defaults = Object.assign({}, _defaults, options);

        if (this.scrollToLinks) {
            this.init();
        }
    }

    //region getters
    get scrollToLinks() {
        return document.querySelectorAll(this.defaults.scrollToLink);
    }

    //endregion

    init() {
        //console.log("ScrollTo init()");

        if (this.scrollToLinks) {
            this.scrollTo();
        }
    }

    scrollTo() {
        for (let link in this.scrollToLinks) {
            if (this.scrollToLinks.hasOwnProperty(link)) {
                this.scrollToLinks[link].addEventListener("click", (ev) => {
                    ev.preventDefault();

                    gsap.to(window, {
                        duration: 1.2,
                        scrollTo: {
                            y: this.scrollToLinks[link].hash,
                            offsetY: parseInt(
                                this.scrollToLinks[link].dataset.scrollToOffset,
                            ),
                        },
                        ease: "expo.inOut",
                        onComplete: () => {},
                    });
                });
            }
        }
    }
}
